<div class="super-admin-inner">
  <div class="sp-admin-list-outer-page">
    <div class="container">
      <div class="st-top-head">
        <div class="row">
          <div class="col-sm-4">
            <div class="search-top">
              <div class="srch-flt-rt">
                <h2>Invoice List</h2>
              </div>
            </div>
          </div>
          <div class="col-sm-8">
            <div class="search-top text-right">
              <form class="example-form" [formGroup]="searchForm">
                <div class="srch-flt-rt mt-frm-srt-t">
                  <mat-form-field class="example-full-width" floatLabel="never">
                    <input matInput placeholder="Search" formControlName="searchList" ng-model-options="{debounce: 10000}"
                           (change)="fn_searchClient(searchForm)">
                    <mat-hint style="font-size: 11px;">*search by invoice number, orderno or po#</mat-hint>
                  </mat-form-field>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div class="search-results" infiniteScroll [infiniteScrollDistance]="1" [infiniteScrollThrottle]="10"
           (scrolled)="fn_GetInvoiceList()">
        <div class="sp-admin-list-tbl pro-tble-outer">
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th>Sr. No</th>
                  <th>Invoice#</th>
                  <th>Order#</th>
                  <th>Invoice Date</th>
                  <th>Due Date</th>
                  <th>PO#</th>
                  <th>Invoice Amount</th>
                  <th>Balance</th>
                  <!--<th class="text-center">Actions</th>-->
                </tr>
              </thead>
              <tbody *ngIf="InvoiceList?.length > 0">
                <tr *ngFor="let item of InvoiceList; let i=index">
                  <td>{{i + 1}}</td>
                  <td>{{item.InvoiceNumber}}</td>
                  <td>{{item.SalesOrder}}</td>
                  <td>{{item.Date}}</td>
                  <td>{{item.DueDate}}</td>
                  <td>{{item.CustomerPO}}</td>
                  <td>{{item.Total}}</td>
                  <td>{{item.Balance}}</td> 
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <mat-card class="spg-mat-card mat-card-cmn" style="display: none;" [ngStyle]="{'display': isDisplay}">
        <mat-card-header>
        </mat-card-header>
        <mat-card-content>
          <div class="text-center">
            <span> No records available</span>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
